import React from "react";

function AdminDashboard() {
  return (
    <div className="container">
      <div
        className="card mb-5 mb-xl-8 h-lg-1000px"
        style={{ marginTop: "140px" }}
      >
        <div style={{ textAlign: "center", fontSize: "50px" }}>
          {" "}
          Admin Dashboard
        </div>
        <div className="card-header border-0 pt-5"></div>
      </div>
    </div>
  );
}

export default AdminDashboard;
